/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { WrappedBridgingBears } from "../WrappedBridgingBears";

export class WrappedBridgingBears__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    name: string,
    symbol: string,
    baseTokenURI: string,
    _bridgingBears: string,
    overrides?: Overrides
  ): Promise<WrappedBridgingBears> {
    return super.deploy(
      name,
      symbol,
      baseTokenURI,
      _bridgingBears,
      overrides || {}
    ) as Promise<WrappedBridgingBears>;
  }
  getDeployTransaction(
    name: string,
    symbol: string,
    baseTokenURI: string,
    _bridgingBears: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      name,
      symbol,
      baseTokenURI,
      _bridgingBears,
      overrides || {}
    );
  }
  attach(address: string): WrappedBridgingBears {
    return super.attach(address) as WrappedBridgingBears;
  }
  connect(signer: Signer): WrappedBridgingBears__factory {
    return super.connect(signer) as WrappedBridgingBears__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WrappedBridgingBears {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as WrappedBridgingBears;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseTokenURI",
        type: "string",
      },
      {
        internalType: "address",
        name: "_bridgingBears",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_tokenIdTracker",
    outputs: [
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bridgingBears",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "unwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "unwrapMulti",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "wrapMulti",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
